import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/attendance-absence-notifications', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const formViewModel = (Options = {}) => {
  return httpClient
    .get('/api/attendance-absence-notifications/form-view-models', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const send = logId => {
  return httpClient
    .post(`/api/attendance-absence-notifications/${logId}/send`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  formViewModel,
  send
}
